import { FaCircleInfo } from "react-icons/fa6";
import { FaFileDownload } from "react-icons/fa";

const NoDataFoundCard = ({ onClick, className, subText = '', hideBtn = true }) => {
  return (
    <div
      className={`w-full p-4 shadow-card-shadow-dark flex flex-col justify-center gap-4 items-center ${className}`}
    >
      <FaCircleInfo className="text-3xl" />
      <p className="text-center">{subText}</p>
      {hideBtn &&
        <button className="p-2 bg-primary-color text-white flex gap-2 items-center rounded-md w-fit" onClick={onClick}>
          <FaFileDownload className="text" />
          Upload Wages
        </button>
      }
    </div>
  )
}

export default NoDataFoundCard